import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { readCheckout, readJoin, type JoinQuery } from "./membership.server";
import { publicationResponse, siteContext } from "./site.server";

const text = (value: unknown) =>
  typeof value === "string" && value.length <= 200 ? value : value == null ? null : undefined;

/** Membership (/join) for a document request or a client navigation. */
export const loadJoin = createServerFn({ method: "GET" })
  .validator((input: unknown): JoinQuery => {
    const { course, content, preview } = (input ?? {}) as Record<string, unknown>;
    const query = { course: text(course), content: text(content) };
    if (query.course === undefined || query.content === undefined) throw notFound();
    return { course: query.course || null, content: query.content, preview: preview === true };
  })
  .handler(async ({ data, context }) => {
    const drate = await siteContext(context);
    const page = await readJoin(drate, data);
    publicationResponse(drate);
    return page;
  });

/** The payment page's shell; its order loads in the browser. */
export const loadCheckout = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  const page = readCheckout(drate);
  publicationResponse(drate);
  return page;
});
